<fieldset
	cdxFieldset
	legend="{{ label }}"
	hideLegend="true"
	[i18n]="'@@dc-form-title'"
	[formGroup]="group"
	layout="large"
>
	<button cdxButton type="submit" [buttonState]="buttonState" [disabled]="disabled">{{ label }}</button>
</fieldset>
